module.exports = __webpack_public_path__ + "media/header-by.13a1db10.mp4";